// @ts-nocheck

/**
 * Browser SDK JSヘルパーモーダルを呼び出す
 * @returns 身元確認ID
 */
export const trustdockBrowserSdk = async (): Promise<string | undefined> => {
  let verificationId
  try {
    const coreEKyc = await window.trustdock.loadCoreEkyc({
      projectId: `${process.env.REACT_APP_TRUSTDOCK_PROJECT_ID}`,
      packageId: `${process.env.REACT_APP_TRUSTDOCK_PACKAGE_ID}`,
    })
    const result = await coreEKyc.start()
    if (result.status === 'completed') {
      const dr1001Result = result.getResult('DR1001')
      if (dr1001Result.result === 'succeeded') {
        verificationId = result.verificationId
      }
    }
  } catch (error) {
    console.error(error)
  }
  return verificationId
}

/**
 * Browser SDK JSヘルパーモーダルのサポート情報を確認
 * @param callback コールバック
 */
export const trustdockBrowserSdkSupportCheck = async (callback?: (supported: boolean, reason: string) => void) => {
  const [supported, reason] = await window.trustdock.supportCoreEkyc()
  console.info('TRUSTDOCK supported: ', supported, 'reason: ', reason)
  if (callback) {
    callback(supported, reason)
  }
}
